import { render } from "./AddQuestionDialog.vue?vue&type=template&id=4ca57683&scoped=true&lang=pug"
import script from "./AddQuestionDialog.vue?vue&type=script&lang=js"
export * from "./AddQuestionDialog.vue?vue&type=script&lang=js"

import "./AddQuestionDialog.vue?vue&type=style&index=0&id=4ca57683&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca57683"]])

export default __exports__